/** AI Bots (Legacy) service — ai-api /ai/bots. */
import constants from '../../constants'
import { getChatApiBase, getChatApiHeaders } from '../chatApiClient'
import axios from '../axiosInstance'
import {
  ChatApp,
  AiBotAddPayload,
  AiBotUpdatePayload,
  AiBotListResponse,
  AiBotResponse,
} from './types'

/** No `useCursoredIndex` here, unlike the custom-bot list. */
export async function list(app: ChatApp, apiHost: string, pageNo = 1): Promise<AiBotListResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/ai/bots?per_page=${
    constants.perPageInListings
  }&page=${pageNo}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function get(id: string, app: ChatApp, apiHost: string): Promise<AiBotResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/ai/bots/${id}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function add(
  post: AiBotAddPayload,
  app: ChatApp,
  apiHost: string,
): Promise<AiBotResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/ai/bots`
  return axios
    .post(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function update(
  id: string,
  post: AiBotUpdatePayload,
  app: ChatApp,
  apiHost: string,
): Promise<AiBotResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/ai/bots/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}

export async function del(id: string, app: ChatApp, apiHost: string): Promise<AiBotResponse> {
  const URL = `${getChatApiBase(app, apiHost)}/ai/bots/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => res.data)
    .catch(error => error?.response?.data ?? Promise.reject(error))
}
